export default __webpack_public_path__ + "static/media/pelvic-floor-foundation.377eacf9.png";